var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.titulo))]),_c('div',{staticClass:"mb-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }